const testLocalStorage = () => {
  // See https://github.com/Modernizr/Modernizr/blob/master/feature-detects/storage/localstorage.js
  const testKey = 'craftcloud_test_local_storage'
  try {
    localStorage.setItem(testKey, testKey)
    localStorage.removeItem(testKey)
    return true
  } catch {
    return false
  }
}

export const hasLocalStorage = testLocalStorage()

export const setItem = (key: string, item: Parameters<typeof JSON.stringify>[0]) => {
  if (hasLocalStorage) {
    window.localStorage.setItem(key, JSON.stringify(item))
  }
}

export const getItem = <T>(key: string): T | null => {
  if (hasLocalStorage) {
    const result = window.localStorage.getItem(key)
    return result && JSON.parse(result)
  }

  return null
}

export const removeItem = (key: string) => {
  if (hasLocalStorage) {
    window.localStorage.removeItem(key)
  }
}
